import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-show-banner',
  templateUrl: './show-banner.component.html',
  styleUrls: ['./show-banner.component.scss']
})
export class ShowBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
